import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=626e83ae&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=626e83ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626e83ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('626e83ae')) {
      api.createRecord('626e83ae', component.options)
    } else {
      api.reload('626e83ae', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=626e83ae&scoped=true&", function () {
      api.rerender('626e83ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sh7aTIf0ruUx/JS/comp/SearchFilterTokens.vue"
export default component.exports